import React, { useEffect, useState, VFC } from 'react';
import { BaseModal } from '../../molecules/BaseModal';
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { TBulkUpdateForm } from '../../../types/attendancManage';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { SiteProcessDatePicker } from '../input/ProcessDatePicker';
import { SiteProcessTextfield } from '../input/ProcessTextfield';
import {
  DECIMAL_VALIDATION,
  validationMessage
} from '../../../const/ProcessConst';
import { updateBulkEvent } from '../../../apicalls/attendanceManages';
import { checkResData } from '../../../utils/common';
import { createGanttResourceAndEvent } from '../../../utils/attendancePage';
import { useSnackbar } from 'notistack';
import { useRecoilState } from 'recoil';
import {
  attendanceAssignTotallOfDate,
  attendanceGanttData
} from '../../../GlobalState';

type TProps = {
  isOpen: boolean;
  setIsOpen: any;
  initialVisibleRange: any;
  bulkSelectId: number;
  initialGanttData: any;
  constructId: number;
  setIsLoadingGantt: any;
};

export const AttendanceBulkUpdateModal: React.FC<TProps> = props => {
  const {
    isOpen,
    setIsOpen,
    initialVisibleRange,
    bulkSelectId,
    initialGanttData,
    constructId,
    setIsLoadingGantt
  } = props;

  const methods: UseFormReturn<TBulkUpdateForm> = useForm({
    reValidateMode: 'onSubmit',
    defaultValues: {
      business_type: 1,
      user_id: 0,
      partner_id: 0,
      start_date: '',
      end_date: '',
      artificial: 0,
      construct_id: 0
    }
  });
  const {
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = methods;

  const classes = useStyles();

  const [, setInitialGanttData] = useRecoilState(attendanceGanttData);
  const [, setAssignTotallOfDate] = useRecoilState(
    attendanceAssignTotallOfDate
  );

  // snackbar
  const { enqueueSnackbar } = useSnackbar();
  const [formInitData, setFormInitData] = useState<any>();

  useEffect(() => {
    if (isOpen) {
      setValue('construct_id', constructId);
      setValue('start_date', initialVisibleRange.start);
      setValue('end_date', initialVisibleRange.end);

      const resources = initialGanttData.resources;
      const tmpData = resources.filter((i: any) => i.id == bulkSelectId)[0];

      const attendance = tmpData.extendedProps.attendance;

      setValue('business_type', attendance.business_type);
      if (attendance.business_type == 1) {
        setValue('user_id', attendance.user_id);
      } else {
        setValue('partner_id', attendance.partner_id);
      }

      setFormInitData(tmpData);
    } else {
      setFormInitData(undefined);
    }
  }, [isOpen]);

  const updateManHours = (form: any) => {
    setIsLoadingGantt(true);

    updateBulkEvent(
      form.business_type,
      form.user_id,
      form.partner_id,
      form.start_date,
      form.end_date,
      Number(form.artificial),
      form.construct_id
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar)
        .then(async (data: any) => {
          if (data) {
            setIsOpen(false);
            const { resources, events, attendanceManageEventList } =
              await createGanttResourceAndEvent(
                constructId,
                enqueueSnackbar,
                initialVisibleRange.start,
                initialVisibleRange.end
              );
            setAssignTotallOfDate(attendanceManageEventList);
            setInitialGanttData({
              resources,
              events
            });
          }
          return;
        })
        .finally(() => {
          setIsLoadingGantt(false);
        });
    });
    setIsOpen(false);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(updateManHours)}
      handleCancelSubmit={() => setIsOpen(false)}
      title={'人工一括編集'}
      buttonCaption={'更新する'}
      cancelButtonCaption={'キャンセル'}
      subDeleteButton={false}
    >
      <FormProvider {...methods}>
        {/* ユーザー名 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>更新対象</label>
        </Grid>
        <Grid item xs={10} md={7}>
          {formInitData && formInitData.title}
        </Grid>
        {/* /ユーザー名 */}

        {/* 期間 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>期間*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <div className={classes.leftAlignContainer}>
            <Grid container>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='start_date'
                    label='開始日'
                    required={true}
                    fullWidth={true}
                    onChange={() => {}}
                    errorMessage={errors?.start_date?.message}
                    className={classes.gridItem}
                    errorMessageStyle={{ display: 'none' }}
                    disabled={true}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={1}>
                <div className={classes.itemMargin} style={{ width: 20 }}>
                  <span className={classes.textStyle}>〜</span>
                </div>
              </Grid>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='end_date'
                    label='終了日'
                    fullWidth={true}
                    onChange={() => {}}
                    className={classes.gridItem}
                    disabled={true}
                  />
                </div>
              </Grid>
              {errors.start_date && (
                <Grid item xs={12}>
                  <div className={`${classes.helperText} ${classes.gridItem}`}>
                    {errors?.start_date?.message}
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        {/* 計画人工 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>計画人工*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <SiteProcessTextfield
            name='artificial'
            className={`${classes.input} ${classes.gridItem}`}
            pattern={DECIMAL_VALIDATION}
            patternMessage={validationMessage.decimal}
            max={9999.99}
            required={true}
            errorMessage={errors?.artificial?.message}
          />
        </Grid>
        {/* /計画人工 */}
      </FormProvider>
    </BaseModal>
  );
};

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    label: {
      width: '100px',
      textAlign: 'left',
      fontSize: 14
    },
    leftAlignContainer: {
      //左寄せ
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
      marginLeft: -3
    },
    itemMargin: {
      margin: '0px 3px'
    },
    textStyle: {
      fontSize: 18
    },
    radioLabel: {
      textAlign: 'left',
      marginRight: 20
    },
    input: {
      width: '100%'
    },
    gridItem: {
      paddingBottom: 10
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginLeft: '16px',
      marginRight: '16px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    }
  });
});
